export type FinanceSelectOption = {
  value: string;
  label: string;
};

export const BUSINESS_GROUP_OPTIONS: FinanceSelectOption[] = [
  { value: '61', label: '61 — BAKERY' },
  { value: '62', label: '62 — CAFE' },
  { value: '63', label: '63 — CATERING' },
  { value: '64', label: '64 — CHURCH/OTHERS' },
  { value: '65', label: '65 — CLUB' },
  { value: '66-1', label: '66-1 — FOOD COURT - FOOD' },
  { value: '66-2', label: '66-2 — FOOD COURT - DRINK' },
  { value: '67-1', label: '67-1 — HOSPITAL' },
  { value: '67-2', label: '67-2 — CLINIC' },
  { value: '68', label: '68 — HOTEL' },
  { value: '69', label: '69 — INSTITUTE CATERING' },
  { value: '70', label: '70 — 3RD PARTY LOGISTICS' },
  { value: '71-1', label: '71-1 — RESTAURANTS - CHINESE' },
  { value: '71-2', label: '71-2 — RESTAURANTS - WESTERN' },
  { value: '71-3', label: '71-3 — RESTAURANTS - JAPANESE' },
  { value: '71-4', label: '71-4 — RESTAURANTS - OTHERS' },
  { value: '72', label: '72 — QUICK SERVE' },
  { value: '73', label: '73 — SUPERMARKET/FOOD PACKER' },
  { value: '74', label: '74 — WHOLESALES' },
  { value: '75', label: '75 — MANUFACTURER' },
];

export const SALESPERSON_OPTIONS: FinanceSelectOption[] = [
  { value: 'SA1 - MK', label: 'SA1 - MK — GOH MOI KIM' },
  { value: 'SA2 - RL', label: 'SA2 - RL — RICKY LIM' },
  { value: 'SA3 - LE', label: 'SA3 - LE — ADMIN TEAM' },
  { value: 'SA4 - RL', label: 'SA4 - RL — QUICK SERVE - RICKY' },
  { value: 'SA5', label: 'SA5 — ADMIN TEAM' },
  { value: 'SA6 - PC', label: 'SA6 - PC — CHONG PING CHAN' },
  { value: 'SA7 - LE', label: 'SA7 - LE — ADMIN TEAM' },
  { value: 'SA8', label: 'SA8 — SUPERMART - RICKY' },
];

export const CUSTOMER_PRICE_GROUP_OPTIONS: FinanceSelectOption[] = [
  'ALPS',
  'BROADWAY',
  'CATERING',
  'CATERING2',
  'CATERING3',
  'COMPASS',
  'COMPASS-C',
  'COMPETITOR',
  'CURATE10%',
  'DA PAOLO',
  'DAIRY FARM',
  'ISS',
  'JUMBO',
  'NTUC',
  'PARADISE',
  'R E & S',
  'SATS',
  'SELECT',
  'SFBI',
  'SHIHLIN',
  'STUFFD',
  'THE WOK',
].map((value) => ({ value, label: value }));

function formatFromOptions(value: string, options: FinanceSelectOption[]): string {
  const trimmed = value.trim();
  if (!trimmed) return '—';
  const match = options.find((opt) => opt.value === trimmed);
  return match?.label ?? trimmed;
}

export function formatBusinessGroupCode(value: string | null | undefined): string {
  return formatFromOptions(value ?? '', BUSINESS_GROUP_OPTIONS);
}

export function formatSalespersonCode(value: string | null | undefined): string {
  return formatFromOptions(value ?? '', SALESPERSON_OPTIONS);
}

export function formatCustomerPriceGroup(value: string | null | undefined): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : '—';
}
